module.exports = __webpack_public_path__ + "img/menu-banner-twk-assist.a82304b7.png";